export class TranslationRequest {
  translationLevel: TranslationLevel;
  merchantId: string;
  languages: string[];
  includeTenantIfMerchantEmpty?: boolean = false;
}

export enum TranslationLevel {
  DEFAULT,
  TENANT,
  MERCHANT
}
